module.exports = __webpack_public_path__ + "img/dingtalk-square.d8716326.svg";